import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@refugedelafoi.ci");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const data = await login(email, password);
      if (data.must_change_password) {
        navigate("/admin/change-password");
      } else {
        navigate("/admin");
      }
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF7F0] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="text-5xl text-[#B8860B] font-display">✟</div>
          <h1 className="font-display text-3xl mt-3">Espace Administrateur</h1>
          <p className="text-xs uppercase tracking-[0.3em] text-[#6B6B6B] mt-2">Refuge de la Foi</p>
        </div>
        <form onSubmit={submit} className="space-y-5 bg-white border border-black/5 p-8" data-testid="admin-login-form">
          <div>
            <label className="label-tiny block mb-1">Email</label>
            <input
              className="input-gold"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              required
            />
          </div>
          <div>
            <label className="label-tiny block mb-1">Mot de passe</label>
            <input
              className="input-gold"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              required
            />
          </div>
          <button type="submit" className="btn-primary w-full" disabled={submitting} data-testid="login-submit-btn">
            {submitting ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
